import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import { addOsmNotification } from "../../redux/actions/toolsActions";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import authService from "../../utils/auth/authService";
import { getDownloadLink } from "../../api/storageApi";

// Task types that should trigger automatic file download on completion
const downloadTaskTypes = [
  "multiCaseFilesDownloader",
  "multiProjectFilesDownloader",
  "multiResultsGeotiffDownloader",
];

// Track downloads that have already been triggered to prevent duplicates
const triggeredDownloads = new Set();

const notificationHubUrl = `${process.env.REACT_APP_FRONT_SERVICE_API}/notifications/custom-tasks`;

const customTasksStatusesToTriggerNotification = [
  "batchInitialization",
  "running",
  "finished",
  "cancelled",
  "aborted",
  "error",
];

const CustomTaskProvider = () => {
  const [connection, setConnection] = useState(null);
  const user = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const start = () => {
    if (connection) {
      if (connection.connectionState === "Connected") {
        return;
      }
      connection
        .start()
        .then(() => {
          connection.on("CustomTaskNotificationReceived", async (message) => {
            const taskNotification = {
              id: message.requestId,
              type: "task",
              body: message,
              ts: message.timestampUtc,
            };
            console.log(taskNotification.body);
            dispatch(addOsmNotification(taskNotification.body));
            if (
              customTasksStatusesToTriggerNotification.includes(
                message?.response?.status
              )
            ) {
              console.log(taskNotification);
            }
            
            // Trigger automatic download when file download tasks complete
            if (
              message.status === 2 &&
              message.response?.resultUrl &&
              downloadTaskTypes.includes(message.type) &&
              !triggeredDownloads.has(message.requestId)
            ) {
              // Mark as triggered to prevent duplicate downloads
              triggeredDownloads.add(message.requestId);
              
              try {
                const url = await getDownloadLink(message.response.resultUrl);
                const link = document.createElement("a");
                link.download = "download";
                link.href = url;
                link.click();
              } catch (error) {
                console.error("Error triggering download:", error);
                // Remove from triggered set so user can retry
                triggeredDownloads.delete(message.requestId);
              }
            }
          });
          connection.onclose(() => {
            setTimeout(() => start(), 3000);
          });
        })
        .catch(async (e) => {
          console.log(
            "Connection failed: ",
            JSON.stringify(e),
            e.statusCode,
            new Date()
          );
          setTimeout(() => start(), 3000);
        });
    }
  };
  useEffect(() => {
    async function subscribeToHub() {
      const newConnection = new HubConnectionBuilder()
        .withUrl(`${notificationHubUrl}`, {
          accessTokenFactory: () => {
            return authService.acquireToken();
          },
        })
        .configureLogging(LogLevel.Warning) // Hide Info/Debug logs from console
        .build();
      setConnection(newConnection);
    }
    if (!user || !user.identity) {
      return;
    }
    subscribeToHub();
  }, [user]);

  useEffect(() => {
    start();
  }, [connection]);

  return null;
};

export default CustomTaskProvider;